const slick = require('slick-carousel');

const slickJs = function () {

    $(document).ready(function () {

        $('.slick-carousel').slick({
            dots: true,
            infinite: false,
            speed: 450,
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: false,
            autoplaySpeed: 3000,
            arrows: true,
            responsive: [
                // {
                //     breakpoint: 992,
                //     settings: {
                //         slidesToShow: 3,
                //         slidesToScroll: 3,
                //         infinite: true,
                //         dots: true
                //     }
                // },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }//,
                // {
                //     breakpoint: 576,
                //     settings: {
                //         slidesToShow: 1,
                //         slidesToScroll: 1
                //     }
                // }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });

        $('.slick-carousel-quotes').slick({
            dots: true,
            infinite: false,
            speed: 450,
            slidesToShow: 1,
            slidesToScroll: 1,
            // autoplay: true,
            // autoplaySpeed: 3000,
            arrows: true
        });
    });
}

export default slickJs;
